module.exports = __webpack_public_path__ + "assets/f8e6711cf80a6eac029c69f75f676fc9.png";